import './effect.js';

import { createIcon } from '../../core/utils/uni-icon.js';
import type { DataViewUILogicBaseConstructor } from '../../core/view/data-view-base.js';
import { chartViewModel } from './define.js';
import { ChartViewUILogic } from './pc/chart-view-ui-logic.js';

export const chartViewMeta = chartViewModel.createMeta({
  icon: createIcon('DatabaseKanbanViewIcon'),
  // No separate mobile logic: the chart view is responsive and is also used on mobile.
  pcLogic: () => ChartViewUILogic as unknown as DataViewUILogicBaseConstructor,
});
